export default class GradeTranslator {
    constructor(ranges) {
        this.ranges = ranges;
    }

    scoreToLetter(score) {
        if (score === null) {
            return '';
        }

        let range = this.getRange(score);

        if (range !== undefined) {
            return range.letters;
        }

        return null;
    }

    scoreToPillColors(score) {
        if (score === null) {
            return '';
        }

        let range = this.getRange(score);

        if (range !== undefined) {
            return range.pillColors;
        }

        return ['', ''];
    }

    scoreToPillClasses(score) {
        if (score === null) {
            return '';
        }

        let range = this.getRange(score);

        if (range !== undefined) {
            return range.pillColors.join(' ');
        }

        return '';
    }

    scoreToPill(score) {
        if (score === null) {
            return {};
        }

        let range = this.getRange(score);

        if (range !== undefined) {
            return {
                decimal_score: score.toPrecision(3),
                color: range.color,
            };
        }

        return {};
    }

    scoreToPillWithLetters(score) {
        if (score === null) {
            return {};
        }

        let range = this.getRange(score);

        if (range !== undefined) {
            return {
                decimal_score: score.toPrecision(3),
                color: range.color,
                letters: range.letters,
                text: range.text,
            };
        }

        return {};
    }

    scoreToColor(score) {
        if (score === null) {
            return 'gray';
        }

        let range = this.getRange(score);

        if (range !== undefined) {
            return range.color;
        }

        return 'gray';
    }

    getRange(score) {
        return this.ranges.find((r) => this.isBetween(score, r.ranges));
    }

    getCounterMap() {
        const map = [];

        this.ranges
            .map((r) => r.letters)
            .forEach((r) => {
                map.push({
                    key: r,
                    value: 0,
                });
            });

        return map;
    }

    // getCounterMap() {
    //
    //     const map = new Map();
    //
    //     this.ranges
    //         .map(r => r.letters)
    //         .forEach(r => {
    //             map.set(r, 0);
    //         });
    //
    //     return map;
    // }

    isBetween(score, range) {
        let rangeStart, rangeEnd, inclusive;
        [rangeStart, rangeEnd, inclusive] = range;

        if (inclusive) {
            return score >= rangeStart && score <= rangeEnd;
        }

        return score >= rangeStart && score < rangeEnd;
    }
}
